import { SubscriptionPlan, SubscriptionPlanName } from "@arelia-types/subscriptions";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import AppContext from "src/AppContext";
import { useSubscriptionDetailsAPI, useUpdateSubscriptionAPI } from "./useSubscriptionDetailsAPI";
import { formatISO } from "date-fns";
import SubscriptionDetailsPresenter from "./SubscriptionDetailsPresenter";
import { Roles } from "@arelia-types/index";

export default function SubscriptionDetailsContainer() {
  const { account } = useContext(AppContext);
  const { id } = useParams();
  const { data, isLoading } = useSubscriptionDetailsAPI(id);
  const identityId = id || account?.identityId;
  const updateMutation = useUpdateSubscriptionAPI(identityId);

  const submitNewPlan = (name: SubscriptionPlan, endDate: Date) => {
    updateMutation.mutate({
      name,
      endDate: formatISO(endDate)
    });
  }

  const activeAmbassadorPlan = data?.plan === SubscriptionPlanName.Free && data?.active;
  const hideChangePlan = account?.role === Roles.Admin || activeAmbassadorPlan;
  const changePlanAvailable = !hideChangePlan;

  return <SubscriptionDetailsPresenter
    isLoading={isLoading}
    changePlanAvailable={changePlanAvailable}
    isAdmin={account?.role === "Admin"}
    subscription={data}
    submitNewPlan={submitNewPlan}
  />;
}
